import { render, staticRenderFns } from "./EventTabs.vue?vue&type=template&id=4a7a1af5&scoped=true&"
import script from "./EventTabs.vue?vue&type=script&lang=ts&"
export * from "./EventTabs.vue?vue&type=script&lang=ts&"
import style0 from "./EventTabs.vue?vue&type=style&index=0&id=4a7a1af5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a1af5",
  null
  
)

export default component.exports